import React, {Component} from "react";
import {connect} from "react-redux";
import {Card, CardText, CardActions, CardHeader} from "material-ui/Card";
import {Toolbar, ToolbarGroup} from "material-ui/Toolbar";
import RaisedButton from "material-ui/RaisedButton";
import ActionCheck from "material-ui/svg-icons/action/check-circle";
import AlertError from "material-ui/svg-icons/alert/error-outline";
import {Title, ViewTitle, translate, ListButton, DELETE} from "admin-on-rest";
import restClient from "../../restClient.js";
import {push as pushAction} from "react-router-redux";
import {showNotification as showNotificationAction} from "admin-on-rest";
import {listStyle} from "./style";

const styles = {
  actions: {zIndex: 2, display: "inline-block", float: "right"},
  toolbar: {clear: "both"},
  button: {margin: "10px 24px", position: "relative"}
};

class BulkDeleteBase extends Component {
  state = {
    deleteNames: [],
    deleteIds: []
  };

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentDidMount() {
    if (!this.props.location.props) this.goBack();
  }

  getBasePath() {
    return `/${this.props.location.props.record.props.name}`;
  }

  handleSubmit(event) {
    event.preventDefault();
    const {showNotification, push} = this.props;
    const deleteRecord = this.props.location.props.record;

    deleteRecord.ids.forEach((id, index) => {
      restClient(DELETE, deleteRecord.props.name, {
        id: id,
        previousData: {}
      }).then(response => {
        this.state.deleteIds.forEach((stateId, nb) => {
          if (stateId === id) {
            function remove(array, element) {
              const index = array.indexOf(element);

              if (index !== -1) {
                array.splice(index, 1);
              }
            }
            remove(this.state.deleteIds, stateId);
          }
        });

        if (!this.state.deleteIds[0]) {
          showNotification("aor.notification.bulk_deleted");
          push(
            `/${
              deleteRecord.props.name
            }/?filter=%7B%7D&order=ASC&page=1&perPage=10`
          );
        }
      });
    });
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    if (this.props.location.props) {
      const {translate} = this.props;
      const record = this.props.location.props.record;

      record.ids.forEach((id, index) => {
        if (id && record.data[id] !== null) {
          if (this.state.deleteNames) {
            if (
              record.data[id].full_name &&
              !this.state.deleteNames.includes(record.data[id].full_name)
            ) {
              this.state.deleteNames.push(record.data[id].full_name);
              this.state.deleteIds.push(id);
              record.deleteNames = this.state.deleteNames;
              record.deleteIds = this.state.deleteIds;
            } else if (
              record.data[id].name &&
              !this.state.deleteNames.includes(record.data[id].name)
            ) {
              this.state.deleteNames.push(record.data[id].name);
              this.state.deleteIds.push(id);
              record.deleteNames = this.state.deleteNames;
              record.deleteIds = this.state.deleteIds;
            } else if (
              record.data[id].short_url &&
              !record.data[id].name &&
              !this.state.deleteNames.includes(record.data[id].short_url)
            ) {
              this.state.deleteNames.push(record.data[id].short_url);
              this.state.deleteIds.push(id);
              record.deleteNames = this.state.deleteNames;
              record.deleteIds = this.state.deleteIds;
            } else if (
              record.data[id].email &&
              !this.state.deleteNames.includes(record.data[id].email)
            ) {
              this.state.deleteNames.push(record.data[id].email);
              this.state.deleteIds.push(id);
              record.deleteNames = this.state.email;
              record.deleteIds = this.state.deleteIds;
            }
          }
        }
      });

      const basePath = this.getBasePath();

      const defaultTitle =
        basePath === "/virtualslips"
          ? translate("aor.action.delete") +
            " " +
            translate("resources.virtualSlips.name").toLowerCase() +
            ":"
          : translate("aor.action.delete") + ":";

      const titleElement = (
        <Title title={defaultTitle} defaultTitle={defaultTitle} />
      );

      const deleteNames = this.state.deleteNames;

      return (
        <div>
          <Card>
            <CardActions style={styles.actions}>
              <ListButton basePath={basePath} />
            </CardActions>
            <ViewTitle title={titleElement} />
            <form onSubmit={this.handleSubmit}>
              <CardHeader>
                <ol style={listStyle.virtualSlipList}>
                  {basePath === "/virtualslips"
                    ? deleteNames.map((val, i) => (
                        <li key={i}>
                          <a href={val} target="_blank" style={listStyle.link}>
                            {val}
                          </a>
                        </li>
                      ))
                    : deleteNames.map((val, i) => <li key={i}>{val}</li>)}
                </ol>
              </CardHeader>

              <CardText>{translate("aor.message.are_you_sure")}</CardText>
              <Toolbar style={styles.toolbar}>
                <ToolbarGroup>
                  <RaisedButton
                    type="submit"
                    label={translate("aor.action.delete")}
                    icon={<ActionCheck />}
                    primary
                    style={styles.button}
                  />
                  <RaisedButton
                    label={translate("aor.action.cancel")}
                    icon={<AlertError />}
                    onClick={this.goBack}
                    style={styles.button}
                  />
                </ToolbarGroup>
              </Toolbar>
            </form>
          </Card>
        </div>
      );
    } else {
      return null;
    }
  }
}

const BulkDelete = translate(BulkDeleteBase);

export default connect(
  null,
  {
    showNotification: showNotificationAction,
    push: pushAction
  }
)(BulkDelete);



// WEBPACK FOOTER //
// ./src/containers/BulkDelete/index.js